import React from "react";
import { IInstrumentDetails, IMeasurementProperties } from '../../models/measurement/InstrumentDetails';
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import Utility from "../shared/Utility";

interface IPropertyTable {
    details?: boolean;
    keyedInSection?: boolean;
    calculatedSection?: boolean;
    meauredSection?: boolean;
    selectedInstrumentDetail: IInstrumentDetails;
    selectedKeyedInDetails?: IKeyedInDetails;
    selectedCalculatedDetails?: ICalculatedDetails;
    selectedDirection?: any;
    thresholdSettings?: IThresholdSettings[];
}

export default class PropertyTable extends React.Component<IPropertyTable> {
    private measuredRow() {
        const items: any[] = [];
        const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
        const countData = selectedInstrumentDetail.countData.find(x => x.selected);
        let selectedPosition = selectedInstrumentDetail.positionCount.find(x => x.selected);
        let selectedDirection: any;
        if (countData !== undefined) {
            selectedDirection = countData.directions.find(x => x.selected);
        }
        if (!selectedDirection) {
            selectedDirection = countData.directions[0];
            selectedDirection.selected = true;
        }

        if (this.props.details) {
            const filteredProps = Utility.getUniquePropertiesFromList(this.props.selectedInstrumentDetail.properties);
            filteredProps?.map((property: any, index: any) => {
                let mean = null;
                let statistics: any = null;
                if (property.directionId === this.props.selectedDirection.id) {
                    if (selectedInstrumentDetail.isAutoLine) {
                        if (selectedInstrumentDetail.statistics !== null || selectedInstrumentDetail.statistics !== undefined || selectedPosition !== undefined) {
                            statistics = selectedInstrumentDetail.statistics.reverse().find(x => x.propertyId === property.id &&
                                x.position === selectedPosition.position);
                            statistics !== undefined ? mean = statistics.mean : null;
                        }
                    } else {
                        if (selectedInstrumentDetail.statistics !== null || selectedInstrumentDetail.statistics !== undefined) {
                            if (selectedPosition !== undefined) {
                                statistics = selectedInstrumentDetail.statistics.find(x => x.propertyId === property.id &&
                                    x.position === selectedPosition.position && x.directionId === property.directionId);
                                // tslint:disable-next-line: no-unused-expression
                                statistics !== undefined ? mean = statistics.mean : null
                            }
                        }
                    }
                    const cpProperty = this.props.selectedInstrumentDetail.currentMeasuringProperty;
                    const cpPosition = this.props.selectedInstrumentDetail.currentMeasuringPosition;
                    if (selectedPosition !== undefined) {
  
                        items.push(<tr className={property.id === cpProperty && selectedPosition.position === cpPosition ? "normal-class active-class" : "normal-class"}
                            key={index}>
                            <td className="text-ellipsis">{property.name} </td>
                            <td>{property.unit || ""}</td>
                            {(mean != null && !isNaN(mean))
                                ? <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Mean")?.colorCode }}>{mean?.toFixed(property?.decimals)}</td>
                                : <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Reject Limit")?.colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                            }

                        </tr>)
                    }
                }

            })
        } else {
            const filteredProps = Utility.getUniquePropertiesFromList(this.props.selectedInstrumentDetail.properties);
            filteredProps?.map((property: any, index: any) => {
                let meanV;
                if (selectedInstrumentDetail?.readings?.length > 0) {
                    meanV = selectedInstrumentDetail.readings[0].directionMeans !== undefined ?
                        selectedInstrumentDetail.readings[0].directionMeans.find(x => x.propertyId === property.id && x.directionId === property.directionId)
                        : undefined;
                }

                if (property.directionId === this.props.selectedDirection.id) {
                    const meanVal = meanV === undefined ? "(--)" : meanV.mean;
                    const meanValue = Math.round(Number(meanVal) * 100) / 100;
                    items.push(<tr className="normal-class" key={index}>
                        <td className="text-ellipsis">{property.name} </td>
                        <td>{property.unit || ""}</td>
                        {isNaN(meanValue)
                            ? <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                            : <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Mean").colorCode }}>{meanValue.toFixed(property.decimals)}</td>
                        }
                    </tr>)
                }

            });
        }
        return items;
    }


    private keyedInRow() {
        const items: any[] = [];
        if (this.props.details) {
            const selectedKeyedInDetails = this.props.selectedKeyedInDetails;
            const countData = selectedKeyedInDetails.countData.find(x => x.selected);
            const selectedPosition = selectedKeyedInDetails.positionCounts.find(x => x.selected);
            const selectedDirection = countData.directions.find(x => x.selected);
            const mean = selectedKeyedInDetails.statistics.find(x => x.directionId === selectedDirection.id &&
                x.position === selectedPosition.position
            )
            const meanVal = (mean != undefined && mean.mean != null && !isNaN(mean.mean)) ? mean.mean : CONSTANTS.NOTCONSIDEREDFORCALC;
            const meanDisplayValue = Math.round(Number(meanVal) * 100) / 100;
            items.push(<tr className="normal-class" key={Math.random()}>
                <td className="text-ellipsis">{this.props.selectedKeyedInDetails.name} </td>
                <td>{this.props.selectedKeyedInDetails.unit || ""}</td>
                {isNaN(meanDisplayValue)
                    ? <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                    : <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Mean").colorCode }}>{meanDisplayValue.toFixed(selectedKeyedInDetails?.decimals)}</td>
                }
            </tr>)

        } else {
      
            items.push(
                <tr className="normal-class" key={Math.random()}>
                    <td className="text-ellipsis">{this.props.selectedKeyedInDetails.name} </td>
                    <td>{this.props.selectedKeyedInDetails.unit || ""}</td>
                    {this.props.selectedKeyedInDetails.propertyMean
                        && this.props.selectedKeyedInDetails.propertyMean.mean != null
                        && !isNaN(this.props.selectedKeyedInDetails.propertyMean.mean)
                        ? <td style={{ color: this.props.thresholdSettings.find(x => x.name === "Mean").colorCode }}>{this.props.selectedKeyedInDetails.propertyMean.mean.toFixed(this.props.selectedKeyedInDetails?.decimals)}</td>
                        : <td style={{ color: this.props.thresholdSettings?.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                    }
                </tr>
            )
        }

        return items;
    }
    public render() {
        if (this.props.selectedKeyedInDetails !== undefined) {
            const kcountData = this.props.selectedKeyedInDetails?.countData?.find(x => x.selected);
            const kselectedDirection = kcountData.directions.find(x => x.selected);
        }
        return (
            <Translation>
                {
                    t =>
                        <div>

                            {this.props.meauredSection && (<table className="sampletbl">
                                <thead>
                                    <tr>
                                        <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_MEAN)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.measuredRow()}
                                </tbody>
                            </table>)}

                            {this.props.keyedInSection && (<table className="sampletbl">
                                <thead>
                                    <tr>
                                        <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_MEAN)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.keyedInRow()}
                                </tbody>
                            </table>)}

                            {this.props.calculatedSection && (<table className="sampletbl">
                                <thead>
                                    <tr>
                                        <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="normal-class" key={Math.random()}>
                                        <td>{this.props.selectedCalculatedDetails.name} </td>
                                        <td>{this.props.selectedCalculatedDetails.unit || ""}</td>
                                    </tr>
                                </tbody>
                            </table>)}
                        </div>
                }
            </Translation>
        )
    }
}
